import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    videos_loading: false,
    date_range: [
      format(subDays(new Date(), 7), 'yyyy-MM-dd'),
      format(addDays(new Date(), 1), 'yyyy-MM-dd')
    ],
    tracks: [],
    track_chart: [],
    videos: [],
    artists: [],
    approval: [],
    page: 1,
    page_size: 10,
    order_column: 'artist',
    order_type: 'asc',
    image: null,
    dialog_track: false,
    track: {},
    genres: [],
    moods: [],
  },

  mutations: {
    setTracks(state, payload) {
      state.tracks = payload
    },
    setTrackChart(state, payload) {
      state.track_chart = payload
    },
    setTrackVideos(state, payload) {
      state.videos = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload[0], payload[1]]
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setVideosLoading(state, payload) {
      state.videos_loading = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    },
    setApproval(state, payload) {
      state.approval = payload
    },
    setImage(state, payload) {
      state.image = payload
    },
    setDialogTrack(state, payload) {
      state.dialog_track = payload
    },
    setTrack(state, payload) {
      state.track = payload
      if (state.track.timing_start)
        state.track.timing = [payload.timing_start, payload.timing_end]
    },
    setGenres(state, payload) {
      state.genres = payload
    },
    setMoods(state, payload) {
      state.moods = payload
    },
  },

  actions: {
    readMyTracks({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('label_track_filter')
      filters = JSON.parse(ls)

      if (
        filters !== null &&
        filters.date_range !== null &&
        filters.date_range.length > 0
      ) {
        filters.date_start = filters.date_range[0]
        filters.date_end = filters.date_range[1]
        delete filters.date_range
      }

      axios.label
        .get('mytracks', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setTracks', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTrackChart({ commit }, data) {
      axios.label
        .get(`mytracks/${data.id}`, {
          params: {
            start: data.start,
            end: data.end,
            charts: true
          }
        })
        .then(r => {
          commit('setTrackChart', r.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          // commit('setLoading', false)
        })
    },

    readTrackVideos({ commit }, id) {
      commit('setVideosLoading', true)
      axios.label
        .get(`mytracks/${id}/video`)
        .then(r => {
          commit('setTrackVideos', r.data)
          commit('setVideosLoading', false)
        })
        .catch(() => {
          commit('setVideosLoading', false)
        })
    },

    readArtists({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('mytracks/artist')
        .then(r => {
          commit('setArtists', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readForApproval({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('mytracks/approval')
        .then(r => {
          commit('setApproval', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    deleteTrack({ dispatch }, id) {
      axios.label
        .post('mytracks/delete/track', {
          track_id: id
        })
        .then(() => {
          dispatch('readForApproval')
        })
    },
    deleteImage({ dispatch }, id) {
      axios.label
        .post('mytracks/delete/image', {
          track_id: id
        })
        .then(() => {})
    },
    confirmTrack({ dispatch }, track) {
      axios.label
        .post('mytracks', {
          id: track.id,
          name: track.name,
          release_date: track.release_date,
          cid_manager: track.cid_manager,
          distributor: track.distributor,
          isrc: track.isrc,
          spotify_link: track.spotify
        })
        .then(() => {
          dispatch('readForApproval')
        })
    },
    updateApprovedTrack({ dispatch }, track) {
      axios.label
        .post('mytracks/approved', {
          id: track.id,
          release_date: track.release_date,
          cid_manager: track.cid_manager,
          distributor: track.distributor,
          isrc: track.isrc,
          spotify_link: track.spotify
        })
        .then(() => {
          dispatch('readMyTracks')
        })
    },

    updatePublish({ dispatch, commit, state }, id) {
      axios.label
          .put(`mytracks/track/${id}`, {
            id: state.track.id,
            title: state.track.title,
            track_genres: state.track.track_genres,
            moods: state.track.moods,
            isrc: state.track.isrc,
            spotify_link: state.track.spotify_link,
            artist_id: state.track.artist[0].id,
            image_url:  state.track.image_url,
            image:  state.image
          })
          .then(() => {
            commit('setDialogTrack', false)
            dispatch('readMyTracks')
          })
    },
  },

  getters: {
    track_chart_views: state => {
      let result = [['Date', 'Views']]
      state.track_chart.map(s => {
        if (s[1] !== 'Views') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), parseInt(s[1])])
        }
      })
      return result
    },
    track_chart_views_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[2] !== 'Daily') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[2]])
        }
      })
      return result
    },
    track_chart_previews: state => {
      let result = [['Date', 'Previews']]
      state.track_chart.map(s => {
        if (s[3] !== 'Previews') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[3]])
        }
      })
      return result
    },
    track_chart_previews_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[4] !== 'Daily Previews') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[4]])
        }
      })
      return result
    },
    track_chart_downloads: state => {
      let result = [['Date', 'Downloads']]
      state.track_chart.map(s => {
        if (s[5] !== 'Downloads') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[5]])
        }
      })
      return result
    },
    track_chart_downloads_daily: state => {
      let result = [['Date', 'Daily Downloads']]
      state.track_chart.map(s => {
        if (s[6] !== 'Daily Downloads') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[6]])
        }
      })
      return result
    },
    track_chart_subscribers: state => {
      let result = [['Date', 'Subscribers']]
      state.track_chart.map(s => {
        if (s[7] !== 'Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[7]])
        }
      })
      return result
    },
    track_chart_subscribers_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[8] !== 'Daily Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[8]])
        }
      })
      return result
    }
  }
}
